// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"fc5d5a7b","376":"fc5d5a7b"}[chunkId] + ".chunk.css";
};